var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.486,
    cy: 16.486,
    r: 16.486,
    fill: "url(#play_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1D1F",
    d: "M12 12.755v6.574c0 1.347 1.463 2.192 2.63 1.518l2.852-1.641 2.85-1.649a1.748 1.748 0 0 0 0-3.03l-2.85-1.648-2.851-1.642c-1.168-.673-2.631.165-2.631 1.518"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "play_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(12.49703 -4.41235 7.58524 21.48355 15.043 15.203)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#FFF280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667,
    stopColor: "#D9B03D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B17B18"
  })))));
};
export default SvgPlay;